import { observer } from 'mobx-react-lite';
import PageSettingsPanel from './PageSettingsPanel';
import type { PageSettingsPanelProps, PageSettingsPanelValueProps } from './types';

export type { PageSettingsPanelProps, PageSettingsPanelValueProps };
export default observer(PageSettingsPanel); // MANUAL OVERRIDE
